App.namespace('views.shared.modal', () => {
  var Modal = function (wrapperElement, overlayElement, {
    onShow = () => {}, onHide = () => {}, onCloseButtonClick = () => {}
  } = {}) {
    this.wrapperElement = wrapperElement;
    this.overlayElement = overlayElement;

    this.onShow = onShow.bind(this);
    this.onHide = onHide.bind(this);
    this.onCloseButtonClick = onCloseButtonClick.bind(this);

    this.attachEvents();
  };

  Modal.prototype.isVisible = function () {
    return this.wrapperElement.classList.contains('ds-modal-wrapper--visible');
  }

  Modal.prototype.show = function () {
    this.wrapperElement.classList.add('ds-modal-wrapper--visible');
    this.overlayElement.classList.add('ds-modal-overlay--visible');
    document.body.classList.add('overflow-hidden');

    this.onShow();
  };

  Modal.prototype.hide = function () {
    this.wrapperElement.classList.remove('ds-modal-wrapper--visible');
    this.overlayElement.classList.remove('ds-modal-overlay--visible');
    document.body.classList.remove('overflow-hidden');

    this.onHide();
  }

  Modal.prototype.attachEvents = function () {
    const self = this;
    const closeButton = this.wrapperElement.querySelector('.ds-modal__close_button');

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        self.onCloseButtonClick();
      });
    }

    const modal = this.wrapperElement.querySelector('.ds-modal');
    modal.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    this.wrapperElement.addEventListener('click', function () {
      self.hide();
    });
  }

  return Modal;
});
